import styled from 'styled-components';

const Button = styled.button`
  position: relative;
  display: inline-block;

  padding: ${props => props.padding ? props.padding : '.375rem 1rem'};
  border-radius: ${props => props.typeCustom ? "4px" : "8px"};
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  cursor: pointer;
  font-weight: ${props => props.typeSort || props.typeCustom ? "normal" : "bold"};;
  font-size: ${props => props.typeSort ? "14px" : "13px"};
  line-height: 24px;
  border: ${props =>  props.noBorder ? "0px" : "1px"} solid #BBC1C8;
  background: #FFFFFF;
  color: ${props =>
    props.primary ?
      "#FFFFFF"
      :
      `${props.textColor ? props.textColor : "#97A0AF"}`
  };
  transition: 0.3s;
  ${props => props.loading && "opacity: 0.5;"}
  &:hover {
    opacity: 0.8;
    background: ${props => props.backgroundColor ? props.backgroundColor : '#f4f5f7'};
    padding: ${props => props.padding ? props.padding : '.375rem 1rem'};
  }
  &:focus {
    outline: 0px;
    border: ${props =>  props.noBorder ? "0px" : "1px"} solid #BBC1C8;
    background: ${props => props.backgroundColor ? props.backgroundColor : 'initial'};
    color: ${props =>
      props.primary ?
        "#FFFFFF"
        :
        `${props.textColor ? props.textColor : "#3A3C40"}`
    };
  }
  &:active{
    outline: 0px;
    border: ${props =>  props.noBorder ? "0px" : "1px"} solid #BBC1C8;
    background: ${props => props.backgroundColor ? props.backgroundColor : 'initial'};
    color: ${props =>
      props.primary ?
        "#FFFFFF"
        :
        `${props.textColor ? props.textColor : "#3A3C40"}`
    };
  }
  &:disabled{
    opacity: 0.5;
    pointer-events: none;
  }
`;

export default Button;
